import { useApolloClient } from '@apollo/client';
import { Store } from '@website/Store';
import { Auth } from '@aws-amplify/auth';
import { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { SupportMessageTags } from '@website/types/graphqlOperations';
import ContactForm from '../contactForm/ContactForm';

export default function CannotFindBooking() {
  const { state, dispatch } = useContext(Store);
  const client = useApolloClient();

  async function handleLogout() {
    client.stop(); // Stop the current client (we'll be getting a signed out one)
    await Auth.signOut(); // Sign out
    dispatch({ type: 'SET_SIGNED_OUT' }); // Update the store
  }

  return (
    <div>
      <p>
        You're currently signed in with the email address{' '}
        <strong>{state.user.email}</strong>. If you're missing a booking, it's
        likely that you have an account registered with a different email
        address or Facebook/Google account.
      </p>
      <p>
        By the way, if you have the original booking confirmation email, we
        recommend signing in with that email address (or the corresponding
        Google/Facebook account).
      </p>

      <p>
        Would you like to try signing in with a different account? You can do
        that by logging out, and then in again.
      </p>

      <Button variant="danger" className="mt-2 mb-4" onClick={handleLogout}>
        Log out
      </Button>

      <h2 className="h4">Still can't find it?</h2>

      <p>
        Please drop us a message below, with any details you can remember,
        including:
      </p>

      <ul>
        <li>Trip name and date.</li>
        <li>Name of person who made the booking.</li>
        <li>Cardholder, and last 4 digits of the card you paid with.</li>
      </ul>

      <ContactForm
        defaultSubject="Can't find my booking"
        messagePlaceholder="Please include as many details as possible here..."
        hideTitle
        tags={[SupportMessageTags.CANT_FIND_BOOKING]}
      />
    </div>
  );
}
